const prompts = [
  {
    heading: 'Кинетическая энергия',
    text: 'Что это такое?',
    textForSend: 'Расскажи мне о кинетической энергии.'
  },
  {
    heading: 'Потенциальная энергия',
    text: 'Объясни простыми словами',
    textForSend: 'Простыми словами расскажи о потенциальной энергии.'
  },
  {
    heading: 'Вторая Мировая Война',
    text: 'Как она повлияла на мир?',
    textForSend: 'Расскажи о том, как Вторая Мировая Война повлияла на мир и к чему привела?'
  },
  {
    heading: 'Курская битва',
    text: 'Составь план для рассказа',
    textForSend: 'Хочу подготовить доклад в школе на тему Курской битвы. Распиши план моего рассказа'
  },
  {
    heading: 'Исторические периоды',
    text: 'Сравни исторические периоды Возрождения и Просвещения',
    textForSend: 'Хочу подготовить доклад в школе на тему сравнения эпох Возрождения и Просвещения.'
  },
]

export default prompts